<ng-container *ngIf="paymentMode">
  <div class="row no-gutters py-3">
    <div class="col-12 mb-po-reference-number">
      <span>{{ 'review.additionalInfo' | cxTranslate }} </span>
      <span class="mb-po-reference-optional">{{ 'address.mandatory' | cxTranslate }}</span>
    </div>
    <span>{{'review.additionalInfoDescription'| cxTranslate}}</span>
    <form class="col-12 mt-3 field-wrapper text-sm-left"
          [formGroup]="form" mbFloatingLabel>
      <label for="poNumberEU"
             class="mb-payment-additional-info-label mb-input-field-cursor mb-custom-label">
        {{ 'address.poInternalRefNum' | cxTranslate }}
      </label>
      <input class="w-100 mb-form-input"
             id="poNumberEU"
             name="poNumber"
             type="text"
             formControlName="poNumber"
             data-cy="mb-billing-address-po-number-input"
             (input)="submitPoNumber()"
             required/>
      <mb-form-errors [control]="form.get(constants.PO_NUMBER_CODE)"
                      [prefix]="'formValidationErrors'">
      </mb-form-errors>
    </form>
  </div>
</ng-container>
